import { SafeResourceUrl } from "@angular/platform-browser";
import { FuseAlertType } from "@fuse/components/alert";

export type PaymentType = 'balance' | 'paypal' | 'stripe';

export type Alert = { type: FuseAlertType; message: string };

export interface Pagination {
    totalLength: number;
    pageSize: number;
    page: number;
}

export class PaginatedData<T> {
    pagination: Pagination;
    data: T[];
    total?: T;

    static readonly EMPTY: PaginatedData<any> = { data: [], pagination: { totalLength: 0, pageSize: 10, page: 0 } };
}

export interface Country {
    uuid: string;
    alpha2: string;
    name: string;
    flagImagePos: string;
    flagImage: SafeResourceUrl;
}

export interface ImageFile {
    fileName: string;
}

export type CdnFileType = 'avatar' | 'artwork' | 'track' | 'logo' | 'favicon' | 'salesreport';
export type ImageCdnFileType = 'avatar' | 'artwork' | 'logo' | 'favicon';

export class CachedData<T> {
    private _time: number;

    constructor(private _value?: T, private _expirationSeconds?: number) {
        this.value = _value;
    }

    get value() {
        if (this._time < Date.now() - this._expirationSeconds * 1000) {
            console.log('Data expired');
            return null;
        }
        return this._value;
    }

    set value(val: T) {
        this._time = Date.now();
    }
}

export interface ObjectLiteral {
    [key: string]: any;
}
